import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import FlexView from 'react-flexview/lib';
import { GridResultsScreen } from './Grid/GridResultsScreen';
import {EuiFlexGroup,EuiSpacer} from '@elastic/eui';
import { USER_PERMISSIONS } from './constants';
import FiltrosMenu from '../../../components/Menus/filtros';
import { Action } from '../../../components/Menus/interface';
import { Menu } from '../../../components/Menus';
import { SelectorFechasDescarga } from './DescargaFacturacion';
import { SelectorDescargaCosteDNSociedad } from './DescargaCosteDNSociedad';
import './styles.css';
import { MaskLoad } from '../../../components/Layout';
import { PERFIL_ADMIN } from '../../../../../shared/constanst/constants';
import { useUserSettings } from '../../../context/CurrentUserContext';

interface Props {
  data: any;
  isLoading: boolean;
  handleFilter(filtro: any): any;
  handleFacturar(dataFacturacion:any):any;
  handleDownloadDatosCoste(filter:any): any;
  handleDownloadDedicacionHoras(filter:any):any;
  handleDownloadDatosFacFinal(dataDownload:any): any;
  handleDownloadDatosFacCP(dataDownload:any): any;
  handleDownloadDatosFacUsuario(dataDownload:any): any;
  handleDownloadDatosFacPorProvincia(dataDownload:any):any;
}

const ControlUsuariosScreen = (props: Props) => {
  const ref:any = useRef();
  const {currentUser}:any = useUserSettings();
  
  let { data, isLoading, handleFilter, handleFacturar,handleDownloadDatosCoste, handleDownloadDedicacionHoras,
    handleDownloadDatosFacFinal,handleDownloadDatosFacCP, handleDownloadDatosFacUsuario, handleDownloadDatosFacPorProvincia
   } = props;

  const permisosUser:any = useMemo(()=>{
    switch (currentUser.perfil) {
      case 'USR':
        return USER_PERMISSIONS.USR
      case 'RAR':
        return USER_PERMISSIONS.RAR
      case 'FIS':
        return USER_PERMISSIONS.FIS
      case 'FAC':
        return USER_PERMISSIONS.FAC
      case 'ADM':
        return USER_PERMISSIONS.ADM
      default:return USER_PERMISSIONS.USR
    }
  },[currentUser])

  
  let [selected, setSelected] = useState<any>([]);
  let [filtro, setFiltro] = useState<any>(undefined)

  useEffect(() => {setSelected([]) }, [data]);

  useEffect(()=> {
    if(filtro!==undefined){
      filtrarPartes();
    }
  },[filtro])
  
  const onExport = () =>{
    ref && ref.current.onExport();
  }

  // const onExportDatosCostes = (fechaDesde:any,fechaHasta:any, tipo:string) =>{
  //   if(tipo==='ES')
  //     handleDownloadDedicacionHoras()
  //   else
  //     handleDownloadDatosCoste(fechaDesde, fechaHasta, currentUser.dni, tipo)
  // }

  const actionsExportDatosCostes = {
      handleDownloadDedicacionHoras,
      handleDownloadDatosCoste
  }

  const onFilterClear = () => { 
    ref.current && ref.current.onFilterClear()
  }

  const onSelected = (selection: any) => {
    setSelected(selection[0])
  }

  // const filtroInicial = (filtroInit:any)=>{
  //   //const filter = {...filtro,...{perfil:profile}}
  //   filtroInit!==undefined && setFiltro(filtroInit);
  //   //handleFilter && handleFilter(filtro)
  // }

  const filtrarPartes = () => {
    handleFilter(filtro)
  }

  // const buildPDF = () => {
  //   CreatePDF();
  // };

  const donwloadsFacturacion = useCallback((dataDownload:any) =>{
    const tipoFact = dataDownload.tipo;
    delete dataDownload.tipo;
    switch (tipoFact) {
      case 'GH':
        handleFacturar(dataDownload)
      break;
      case 'CP':
        handleDownloadDatosFacCP(dataDownload)
      break;
      case 'FF':
        handleDownloadDatosFacFinal(dataDownload)
      break;
      case 'FU':
        handleDownloadDatosFacUsuario(dataDownload)
      break;
      case 'PV':
        handleDownloadDatosFacPorProvincia(dataDownload)
      break;
      default:
        break;
    }
  },[currentUser,PERFIL_ADMIN])

  const Actions = useMemo(():Action[] => [
    {handle:onFilterClear,text:"Limpiar Filtro",size:"s", isDisabled: false, className: "btnFilterClear"},
    {isDisabled: false, component: permisosUser.descCoste ? <SelectorDescargaCosteDNSociedad onSave={actionsExportDatosCostes}/> : null},
    {isDisabled: false, component: permisosUser.descFacturacion ? <SelectorFechasDescarga onDownLoad={donwloadsFacturacion} showFacturacionUser={permisosUser} onFacturar={handleFacturar}/> : null},
    {handle:onExport,text:"Exportar",size:"s", isDisabled:false}
  ],[onFilterClear,permisosUser,actionsExportDatosCostes,onExport,donwloadsFacturacion,handleFacturar])

  const getView = () => {
    return (
      <>
        <GridResultsScreen
          data={data}
          filtro={filtro}
          selector={false}
          onSelected={onSelected}
          onChange={()=>{}}
          ref={ref}
        />
      </>
    )
  }

  return (
    <>
    <MaskLoad isLoading={isLoading}/>
    <FlexView column basis="100%">
        <EuiFlexGroup gutterSize="s" alignItems="center" className="wrapperMenuPage">
          <EuiFlexGroup alignItems={'center'} justifyContent="flexStart" className="filter">
            <FiltrosMenu onChangeFilter={setFiltro} selectorSociedades/>
          </EuiFlexGroup>
          <Menu actions={Actions} className="actions"/>
         </EuiFlexGroup>
        <EuiSpacer size="m" />
      <FlexView grow={1} shrink={1} basis="auto">
        <FlexView column shrink={0} basis="100%">
          {getView()}
        </FlexView>
      </FlexView>
    </FlexView>
    </>
  );
};

export default ControlUsuariosScreen;
